module.exports = __webpack_public_path__ + "static/media/aulas-de-revisao.f6013181.jpg";